/* 负责网络通讯，可以很方便的替换 */
var wilddog = require("wilddog");
var web = (function () {
	function web() { }
	web.prototype = {}
	web.init = function () {
		var config = {
			syncURL: "https://hanshitu.wilddogio.com"
		};
		wilddog.initializeApp(config);
		web.wilddogRef = wilddog.sync().ref();
		return web.wilddogRef
	}
	web.sync = function (url, cb) {
		var ref = web.wilddogRef ? web.wilddogRef.child(url) : web.init().child(url);
		ref.on('value', cb);
	}
	//feedback
	web.add = function (url, obj, cb) {
		var ref = web.wilddogRef ? web.wilddogRef.child(url) : web.init().child(url);
		ref.child('counter').transaction(function (currentValue) {
			return (currentValue || 0) + 1;
		}, function (err, committed, snapshot) {
			if (err) {
				console.log("err: " + err);
			} else if (committed) {
				var id = snapshot.val();
				obj.id = id;
				ref.child(id).set(obj, function (error) {
					if (error == null) {
						// 数据同步到野狗云端成功完成
						cb({ id: id, value: obj })
					} else {
						var myerror = 'add' + url + '错误：' + error
						alert(myerror);
						console.log(myerror)
					}
				});
			}
		});
	}

	//find feedback/1 下面的email
	web.findone = function (url, field, value, cb) {
		var ref = web.wilddogRef ? web.wilddogRef.child(url) : web.init().child(url);
		ref.orderByChild(field).startAt(value).endAt(value).once('value', cb);
	}
	//可以实现排序、分页（数据结构设计一下）
	web.find = function (obj) {
		var url = obj.url,
			field = obj.field,
			startValue = obj.startValue,
			cb = obj.callback;
		var ref = web.wilddogRef ? web.wilddogRef.child(url) : web.init().child(url);
		if (field == 'id') {
			var limitnum = obj.limitnum || 10
			var endValue = obj.endValue || (startValue + limitnum)
			ref.orderByPriority().startAt(startValue).endAt(endValue).once('value', cb);
		} else {
			var endValue = obj.endValue || startValue
			ref.orderByChild(field).startAt(startValue).endAt(endValue).once('value', cb);
		}

	}
	///user/2
	web.get = function (url, cb) {
		var ref = web.wilddogRef ? web.wilddogRef.child(url) : web.init().child(url);
		ref.once('value', cb);
	}
	return web;
}());

export default web;


// WEBPACK FOOTER //
// ./src/webhelper.js